var getGridLocalisation = function() {
  var dayPm = i18n('fe.common.calendar.pm', 'nachmittag');
  var dayAm = i18n('fe.common.calendar.am', 'vormittag');
  var localizationobj = {
    month: i18n('fe.common.date.month', 'Monat'),
    week: i18n('fe.common.date.week', 'Woche'),
    day: i18n('fe.common.date.day', 'Tage'),
    allDay: i18n('fe.common.calendar.allDay', 'Ganztägig'),
    today: i18n('fe.common.date.today', 'Heute'),
    emptydatastring: ' ',
    firstDay: 1,
    days: {
      // full day names
      names: [
        i18n('fe.common.day.sun', 'Sonntag'),
        i18n('fe.common.day.mon', 'Montag'),
        i18n('fe.common.day.tue', 'Dienstag'),
        i18n('fe.common.day.wen', 'Mittwoch'),
        i18n('fe.common.day.thu', 'Donnerstag'),
        i18n('fe.common.day.fri', 'Freitag'),
        i18n('fe.common.day.sat', 'Samstag')
      ],
      // abbreviated day names
      namesAbbr: [
        i18n('fe.common.day.sun.short', 'So'),
        i18n('fe.common.day.mon.short', 'Mo'),
        i18n('fe.common.day.tue.short', 'Di'),
        i18n('fe.common.day.wen.short', 'Mi'),
        i18n('fe.common.day.thu.short', 'Do'),
        i18n('fe.common.day.fri.short', 'Fr'),
        i18n('fe.common.day.sat.short', 'Sa')
      ],
      // shortest day names
      namesShort: [
        i18n('fe.common.day.sun.short', 'So'),
        i18n('fe.common.day.mon.short', 'Mo'),
        i18n('fe.common.day.tue.short', 'Di'),
        i18n('fe.common.day.wen.short', 'Mi'),
        i18n('fe.common.day.thu.short', 'Do'),
        i18n('fe.common.day.fri.short', 'Fr'),
        i18n('fe.common.day.sat.short', 'Sa')
      ]
    },
    months: {
      // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
      names: [
        i18n('fe.common.month.jan', 'Januar'),
        i18n('fe.common.month.feb', 'Februar'),
        i18n('fe.common.month.mar', 'März'),
        i18n('fe.common.month.apr', 'April'),
        i18n('fe.common.month.may', 'Mai'),
        i18n('fe.common.month.jun', 'Juni'),
        i18n('fe.common.month.jul', 'Juli'),
        i18n('fe.common.month.aug', 'August'),
        i18n('fe.common.month.sep', 'September'),
        i18n('fe.common.month.oct', 'Oktober'),
        i18n('fe.common.month.nov', 'November'),
        i18n('fe.common.month.dec', 'Dezember'),
        ''
      ],
      // abbreviated month names
      namesAbbr: [
        i18n('fe.common.month.jan.short', 'Jän'),
        i18n('fe.common.month.feb.short', 'Feb'),
        i18n('fe.common.month.mar.short', 'Mär'),
        i18n('fe.common.month.apr.short', 'Apr'),
        i18n('fe.common.month.may.short', 'Mai'),
        i18n('fe.common.month.jun.short', 'Jun'),
        i18n('fe.common.month.jul.short', 'Jul'),
        i18n('fe.common.month.aug.short', 'Aug'),
        i18n('fe.common.month.sep.short', 'Sept'),
        i18n('fe.common.month.oct.short', 'Okt'),
        i18n('fe.common.month.nov.short', 'Nov'),
        i18n('fe.common.month.dec.short', 'Dez'),
        ''
      ]
    },
    // AM and PM designators in one of these forms:
    // The usual view, and the upper and lower case versions
    // [standard,lowercase,uppercase]
    // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
    // null
    AM: [dayAm.capitalize(), dayAm, dayAm.capitalize()],
    PM: [dayPm.capitalize(), dayPm, dayPm.capitalize()],
    eras: [
      // eras in reverse chronological order.
      // name: the name of the era in this culture (e.g. A.D., C.E.)
      // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
      // offset: offset in years from gregorian calendar
      {
        name: i18n('fe.common.date.eras.short', 'n. Chr.'),
        start: null,
        offset: 0
      }
    ],
    twoDigitYearMax: 2100,
    patterns: {
      // short date pattern
      d: i18n('fe.common.calendar.pattern.d', 'dd.MM.yyyy'),
      // long date pattern
      D: i18n('fe.common.calendar.pattern.D', 'dddd, am dd.MM.yyyy'),
      // short time pattern
      t: i18n('fe.common.calendar.pattern.t', 'HH:mm'),
      // long time pattern
      T: i18n('fe.common.calendar.pattern.T', 'hh:mm:ss tt'),
      // long date, short time pattern
      f: i18n('fe.common.calendar.pattern.f', 'dd.MM.yyyy h:mm'),
      // long date, long time pattern
      F: i18n('fe.common.calendar.pattern.F', 'dddd, MMMM dd, yyyy h:mm:ss tt'),
      // month/day pattern
      M: i18n('fe.common.calendar.pattern.M', 'MMMM dd'),
      // month/year pattern
      Y: i18n('fe.common.calendar.pattern.Y', 'yyyy MMMM'),
      // S is a sortable format that does not vary by culture
      S: i18n(
        'fe.common.calendar.pattern.S',
        'yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss'
      )
    },
    calendarColumnFormat: {
      month: i18n('fe.common.calendar.pattern.tiny.column.month', 'dddd'),
      week: i18n('fe.common.calendar.pattern.tiny.column.week', 'ddd, dd.MM'),
      day: i18n('fe.common.calendar.pattern.tiny.column.day', 'dddd, dd.MM')
    },
    calendarTitleFormat: {
      // keep " instead of ' to allow ' in pattern texts
      month: i18n('fe.common.calendar.tiny.pattern.title.month', 'MMMM yyyy'),
      week: i18n(
        'fe.common.calendar.tiny.pattern.title.week',
        "d. [ MMM] [ yyyy]{ 'bis' d. MMM yyyy}"
      ),
      day: i18n(
        'fe.common.calendar.tiny.pattern.title.day',
        'dddd, d. MMMM yyyy'
      )
    },
    percentsymbol: '%',
    currencysymbol: '€',
    currencysymbolposition: 'after',
    decimalseparator: ',',
    thousandsseparator: '.',
    pagergotopagestring:
      i18n('fe.common.calendar.pagergotopagestring', 'Gehe zu') + ':',
    pagershowrowsstring:
      i18n('fe.common.calendar.pagershowrowsstring', 'Zeige Zeile') + ':',
    pagerrangestring:
      ' ' + i18n('fe.common.calendar.pagerrangestring', 'von') + ' ',
    pagerpreviousbuttonstring:
      i18n('fe.common.calendar.pagerpreviousbuttonstring', 'voriger') + ':',
    pagernextbuttonstring:
      i18n('fe.common.calendar.pagernextbuttonstring', 'nächster') + ':',
    groupsheaderstring: i18n(
      'fe.common.calendar.groupsheaderstring',
      'Ziehen Sie eine Spalte hierher um nach ihr gruppieren'
    ),
    sortascendingstring: i18n(
      'fe.common.calendar.sortascendingstring',
      'Sortiere aufsteigend'
    ),
    sortdescendingstring: i18n(
      'fe.common.calendar.sortdescendingstring',
      'Sortiere absteigend'
    ),
    sortremovestring: i18n(
      'fe.common.calendar.sortremovestring',
      'Entferne Sortierung'
    ),
    groupbystring: i18n(
      'fe.common.calendar.groupbystring',
      'Gruppiere nach dieser Spalte'
    ),
    groupremovestring: i18n(
      'fe.common.calendar.groupremovestring',
      'Entferne Gruppierung'
    ),
    filterclearstring: i18n('fe.common.calendar.filterclearstring', 'Aufheben'),
    filterstring: i18n('fe.common.calendar.filterstring', 'Filter'),
    filtershowrowstring: i18n(
      'fe.common.calendar.filtershowrowstring',
      'Zeige Zeilen wo:'
    ),
    filterorconditionstring: i18n(
      'fe.common.calendar.filterorconditionstring',
      'Oder'
    ),
    filterandconditionstring: i18n(
      'fe.common.calendar.filterandconditionstring',
      'Und'
    ),
    filterstringcomparisonoperators: [
      i18n('fe.common.calendar.filterstringcomparisonoperators.empty', 'leer'),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.notEmpty',
        'nicht leer'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.contains',
        'enthält'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.containsCaseSensitive',
        'enthält(Klein-/Großschreibung beachten)'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.notContains',
        'enthält nicht'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.notContainsCaseSensitive',
        'enthält nicht(Klein-/Großschreibung beachten)'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.startsWith',
        'startet mit'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.startsWithCaseSensitive',
        'startet mit(Klein-/Großschreibung beachten)'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.entsWith',
        'endet mit'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.endsWithCaseSensitive',
        'endet mit(Klein-/Großschreibung beachten)'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.equals',
        'gleich'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.equalsCaseSensitive',
        'gleich(Klein-/Großschreibung beachten)'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.undefined',
        'undefiniert'
      ),
      i18n(
        'fe.common.calendar.filterstringcomparisonoperators.notUndefined',
        'nicht undefiniert'
      )
    ],
    filternumericcomparisonoperators: [
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.equal',
        'gleich'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.notEqual',
        'ungleich'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.before',
        'früher als'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.beforeOrEqual',
        'früher gleich'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.after',
        'später als'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.afterOrEqual',
        'später gleich'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.undefined',
        'undefiniert'
      ),
      i18n(
        'fe.common.calendar.filternumericcomparisonoperators.notUndefined',
        'nicht undefiniert'
      )
    ],
    filterdatecomparisonoperators: [
      i18n('fe.common.calendar.filterdatecomparisonoperators.equal', 'gleich'),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.notEqual',
        'ungleich'
      ),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.before',
        'früher als'
      ),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.beforeOrEqual',
        'früher gleich'
      ),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.after',
        'später als'
      ),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.afterOrEqual',
        'später gleich'
      ),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.undefined',
        'undefiniert'
      ),
      i18n(
        'fe.common.calendar.filterdatecomparisonoperators.notUndefined',
        'nicht undefiniert'
      )
    ],
    validationstring: i18n(
      'fe.common.calendar.validationstring',
      'Der eingegebene Wert ist nicht gültig'
    )
  };
  return localizationobj;
};

global.getGridLocalisation = getGridLocalisation;

var getDatePickerSettings = function() {
  var settings = {
    clearText: i18n('fe.common.delete', 'löschen'),
    clearStatus: i18n(
      'fe.common.calendar.deleteState',
      'aktuelles Datum löschen'
    ),
    closeText: i18n('fe.common.close', 'schließen'),
    closeStatus: i18n('fe.common.cancel', 'ohne Änderungen schließen'),
    prevText: i18n('fe.common.back', 'zurück'),
    prevStatus: i18n(
      'fe.common.calendar.previousMonth',
      'letzten Monat zeigen'
    ),
    nextText: i18n('fe.common.forth', 'Vor'),
    nextStatus: i18n(
      'fe.common.calendar.previousMonth',
      'nächsten Monat zeigen'
    ),
    currentText: i18n('fe.common.date.today', 'heute'),
    currentStatus: '',
    monthNames: getGridLocalisation().months.names.slice(0, 12),
    monthNamesShort: getGridLocalisation().months.namesAbbr.slice(0, 12),
    monthStatus: i18n(
      'fe.common.calendar.otherMonth',
      'anderen Monat anzeigen'
    ),
    yearStatus: i18n('fe.common.calendar.otherMonth', 'anderes Jahr anzeigen'),
    weekHeader: i18n('fe.common.date.week.short', 'Wo'),
    weekStatus: i18n('fe.common.date.weekOfMonth', 'Woche des Monats'),
    dayNames: getGridLocalisation().days.names,
    dayNamesShort: getGridLocalisation().days.namesAbbr,
    dayNamesMin: getGridLocalisation().days.namesAbbr,
    dayStatus: i18n(
      'fe.common.calendar.dayState',
      'Setze DD als ersten Wochentag'
    ),
    dateStatus: i18n('fe.common.calendar.dateState', 'Wähle D, M d'),
    dateFormat: i18n('fe.common.datepicker.pattern.d', 'dd.mm.yy'),
    firstDay: 1,
    initStatus: i18n('fe.common.calendar.select', 'Wähle ein Datum'),
    isRTL: false,
    yearRange: '1900:2050'
  };
  return settings;
};

global.getDatePickerSettings = getDatePickerSettings;
